import { AiReview_Read_Nested, Principal_Read_Nested } from '@treadinc/horizon-api-spec';
import dayjs, { Dayjs } from 'dayjs';

import { Nullable } from '~types/Nullable';

export class AiReview {
  public static parse(proto: AiReview_Read_Nested): AiReview {
    return new AiReview(
      proto.id,
      proto.status,
      proto.confidence ? parseFloat(proto.confidence) : null,
      proto.summary ?? null,
      proto.reasoning ?? null,
      proto.issues ?? [],
      dayjs(proto.created_at),
      dayjs(proto.updated_at),
      proto.discarded_at ? dayjs(proto.discarded_at) : null,
      proto.dismissed_at ? dayjs(proto.dismissed_at) : null,
      proto.dismissed_by ?? null,
    );
  }

  public get id() {
    return this._id;
  }

  public get status() {
    return this._status;
  }

  public get confidence() {
    return this._confidence;
  }

  public get summary() {
    return this._summary;
  }

  public get reasoning() {
    return this._reasoning;
  }

  public get issues() {
    return this._issues;
  }

  public get createdAt() {
    return this._createdAt;
  }

  public get updatedAt() {
    return this._updatedAt;
  }

  public get discardedAt() {
    return this._discardedAt;
  }

  public get dismissedAt() {
    return this._dismissed_at;
  }

  public get dismissedBy() {
    return this._dismissed_by;
  }

  constructor(
    private _id: string,
    private _status: AiReview_Read_Nested['status'],
    private _confidence: Nullable<number>,
    private _summary: Nullable<string>,
    private _reasoning: Nullable<string>,
    private _issues: string[],
    private _createdAt: Dayjs,
    private _updatedAt: Dayjs,
    private _discardedAt: Dayjs | null = null,
    private _dismissed_at: Dayjs | null = null,
    private _dismissed_by: Principal_Read_Nested | null = null,
  ) {}
}
